export default __webpack_public_path__ + "static/bravo-4-9afee1811daadb8eaa24275e54d45c04.jpg";